import { FormScaffold } from "@repo/core/components/layout/Scaffolds/FormScaffold";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { RootScaffold } from "@repo/core/components/layout/Scaffolds/RootScaffold";
import { StoreSelectScaffold } from "@repo/core/components/layout/Scaffolds/StoreSelectScaffold";

export default {
  Root: RootScaffold,
  Form: FormScaffold,
  Page: PageScaffold,
  StoreSelect: StoreSelectScaffold
};
